import { images } from "../../constants";

const testimonialData = [
  {
    id: 1,
    name: 'CEO, International Startup',
    designation: 'Business Expansion Client',
    imgUrl: images.fikayo,
    feedback: 'Scoolj Institute helped us expand strategically into Nigeria. Their insights and execution were excellent. The market research and cultural intelligence they provided was invaluable for our successful entry.'
  },
  {
    id: 2,
    name: 'Business Owner',
    designation: 'Technology Client',
    imgUrl: images.osanyin,
    feedback: 'The software solution built by Scoolj Lab transformed our customer experience. Their end-to-end development process and attention to user experience exceeded our expectations.'
  },
  {
    id: 3,
    name: 'Training Coordinator',
    designation: 'Education Sector',
    imgUrl: images.fikayo,
    feedback: 'The digital skills training provided by Scoolj Institute equipped our team with practical, industry-aligned competencies. The impact on our productivity has been remarkable.'
  }
]

export default testimonialData;